/**
 * @file   src\pages\MemberEditWantAd.js
 * @brief  Want-Listings not created by an agent come from the retired consumer
 *         flow and can no longer be edited. This route used to open a form whose
 *         save had been disconnected, so it now sends the user to the listing.
 */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { pageURLs } from "@/constants";

const MemberEditWantAd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const wantAdId = location.state?.data?.wantAdId;

  useEffect(() => {
    toast.info("This Want-Listing can no longer be edited.", {
      toastId: "legacy-want-ad-edit",
    });
    navigate(
      wantAdId ? `${pageURLs.wantAdDetails}/${wantAdId}` : pageURLs.home,
      { replace: true },
    );
  }, [navigate, wantAdId]);

  return null;
};

export default MemberEditWantAd;
